import React from 'react';

import { Modal, H4 } from '@bigcommerce/big-design';

const OrderNotesDialog = ({ setDisplayOrderNotes, orderComments, privateAdminNotes, focusScanArea }) => {
  const close = () => {
    setDisplayOrderNotes(false);
    focusScanArea();
  }

  return(
    <div className="main-overlay main-overlay__info">
      <Modal
        actions={[
          { 
            text: 'Close', 
            onClick: () => close()
          },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        backdrop={false}
        isOpen={true}
        onClose={() => close()}
        variant="dialog"
      >
        <br/>
        <H4>Customer Message</H4>
        <div>
          <span className="left-15">{orderComments}</span>
        </div>
        <br/>
        <br/>
        <H4>Staff Notes</H4>
        <div>
          <span className="left-15">{privateAdminNotes}</span>
        </div>
      </Modal>
    </div>
  )
}

export default OrderNotesDialog;